import React, { Component } from 'react';
import moment from 'moment';

import OrderedProduct from './OrderedProduct';
import './Order.css';

export default class Order extends Component {
  constructor(props) {
    super(props);
  }

	render() {
		const order = this.props.order;
		let products = [];
		let totalPrice = 0;
		if (order.productList && order.productList.length > 0) {
			products = order.productList.map(product => <OrderedProduct calculatePrice={ this.props.calculatePrice } productCart={ this.props.productCart } productCartIds={ this.props.productCartIds } syncProducts={ this.props.syncProducts } key={ product.id } product={ product } handleReorder={ this.props.handleReorder } productsArrKey={ this.props.productsArrKey } syncProductsIndividualItems={ this.props.syncProductsIndividualItems } ordInd={ this.props.ordInd } handleReturn={ this.props.handleReturn } orderId={ order.userOrderDTO.sourceOrderId }/>);
			order.productList.forEach(product => {
				totalPrice += parseFloat(parseFloat(product.price).toFixed(2));
			});
    }
    
    var attributes = {
      promoCode : 0, 
      amountPaidGateFee : 0,
      newSubtotal : 0
    }
   
    var order_number = '';
    if(order.shopifyOrder != null){
      order.shopifyOrder.note_attributes.forEach(response => {
        attributes[response.name] = response.value
      })
      order_number = order.shopifyOrder.order_number
    }

		const trackingUrl = order.userOrderDTO.trackingUrl;
		return (
			<div className="order">
				<div className="info">
					<div className="left-section">
						<div><span>Order number:</span> { order_number }</div>
						<div className="total-and-date">
							<div className="total"><span>Total: $</span>{ totalPrice.toFixed(2) }</div>
							<div className="orderedon-sty"><span>Ordered on:</span> { moment(order.userOrderDTO.createdDate).format('MM/DD/YYYY') }</div>
						</div>
					</div>
					<div className="right-section">
						{ trackingUrl && <a href={ trackingUrl } target="_blank">Track package</a> }
					</div>
				</div>
				<div className="ordered-products">
					{ products }
				</div>
				<div className="order-separator-line"></div>
				<div className="pricing-detail">
				 	<ul className="pricing-detail-ul">
           <li className="pricing-detail-ul-subtotal">
              <span>Subtotal</span>
              <span>${order.userOrderDTO.subtotal}</span>
           </li>
           {
             attributes['amountPaidGateFee'] != 0 ?
              <li>
                <span>Consultation fee credit</span>
                <span>{attributes['amountPaidGateFee']}</span>
              </li> : null
           }
           {
             attributes['promoCode'] !=0 ?
             <li>
              <span>Promo code</span>
              <span>{attributes['promoCode']}</span>
             </li>: null
           }
           {
             attributes['newSubtotal'] != 0 ? 
             <li>
              <span>New subtotal</span>
              <span>{attributes['newSubtotal']}</span>
            </li>: null
           }
           <li>
              <span>Tax</span>
              <span>{order.userOrderDTO.tax}</span>
           </li>
           <li>
              <span>Shipping</span>
              <span>{order.userOrderDTO.shipping}</span>
           </li>
           <li className="pricing-detail-ul-subtotal">
              <span>Total</span>
              <span>{order.userOrderDTO.gross}</span>
           </li>
					</ul>
				</div>
				
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/order/Order.js